define('SearchSpring.Facets.ApiParameters', [
    'Profile.Model'
], function SearchSpringFacetsApiParams(
    ProfileModel
) {
    'use strict';

    return {
        getApiParams: function getApiParams() {
            var profile = ProfileModel.getInstance();
            var store = profile.get('store');
            var storeId = store && store.get('name');
            return {
                'bgfilter.custitem_sca_store': storeId
            };
        }
    };
});
